import Login from "../src/pages/login/Login";
import Dashboard from "../src/pages/dashboard/Dashboard";
import Plan from "../src/pages/planmaker/Plan";

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Goal from "./pages/goalDashboard/Goal";
function App() {
  return (
    <Router>
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/createPlan" element={<Plan />} />
      <Route path="/goals" element={<Goal />} />


      
    </Routes>
  </Router>
  );
}

export default App;
